import React from 'react';
import { NavLink } from 'react-router-dom';
const Home = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-5xl font-bold text-white mb-4">
                    Welcome to <span className="text-blue-400">ProjectLock</span>
                </h1>
                <p className="text-gray-400 text-lg mb-8">
                    Admin Dashboard
                </p>
                <div className="flex gap-4 justify-center">
                    <button className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-blue-500/25">
                        <NavLink
                            to="/dashboard/leads"
                            className="text-white font-medium"
                        >
                            Get Started
                        </NavLink>
                    </button>
                 
                </div>
            </div>
        </div>
    );
};

export default Home;
